import React, { useEffect, useState } from "react";

import { useParams, useNavigate } from "react-router-dom";
import API from "../api";
import Sidebar from "./Sidebar";
import Navbar from "./Navbar";
import "./AttendanceHistory.css"; // reuse same CSS

export default function LeaveHistory() {
    const navigate = useNavigate();
  const { userId } = useParams();
  const [history, setHistory] = useState([]);
  const [sidebarOpen, setSidebarOpen] = useState(true);

  const toggleSidebar = () => setSidebarOpen(!sidebarOpen);

  useEffect(() => {
    API.get(`/attendance/leavehistory/${userId}`).then((res) => {
      setHistory(res.data);
    });
  }, [userId]);

  // Format date like: Nov 26, 2025
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "2-digit",
    });
  };

  return (
    <div className="dashboard-wrapper">
      {/* Sidebar */}
      <div className={`sidebar-container ${sidebarOpen ? "open" : "closed"}`}>
        <Sidebar />
      </div>

      <div className={`page-area ${sidebarOpen ? "" : "full"}`}>
        <Navbar sidebarOpen={sidebarOpen} toggleSidebar={toggleSidebar} />

        <div className="main-content">
          <div className="container-fluid py-4">
            {/* Dashboard Title */}
            <div className="dashboard-title">
              <img
                src="/Dashboard-Red-64.png"
                alt="dashboard"
                className="dashboard-icon"
              />
              <span>Dashboard</span>
            </div>

            <div style={{ padding: 20 }}>
             <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  marginBottom: 20,
                }}
              >
                <h2 style={{ margin: 0 }}>Leave History</h2>

                <button
                  onClick={() => navigate("/AdminDashboard/leaveAttendance")}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "6px",
                    background: "#ed3338",
                    color: "#fff",
                    border: "none",
                    padding: "6px 19px",
                    borderRadius: "20px",
                    cursor: "pointer",
                    fontSize: "14px",
                    marginRight: "12px"
                  }}
                >
                  ← Back
                </button>
              </div>

              {history.length === 0 ? (
                <p style={{ textAlign: "center", color: "#777" }}>
                  No Leave History Found
                </p>
              ) : (
                <div className="history-grid">
                  {history.map((leave, index) => {
                    const colors = [
                      "rgba(252,125,19,0.1)", // orange
                      "rgba(75,174,80,0.1)",  // green
                      "rgba(32,149,243,0.1)", // blue
                      "rgba(237,51,56,0.1)",  // red
                    ];

                    return (
                      <div
                        key={index}
                        className="history-card"
                        style={{ background: colors[index % colors.length] }}
                      >
                        <div className="history-date">
                          {formatDate(leave.date)}
                        </div>

                        <div className="history-hours">
                          📌 {leave.subject}
                        </div>

                        <div className="history-reason">
                          {leave.reason || "—"}
                        </div>

                        <div
                          className={`history-status ${leave.approval_status}`}
                        >
                          {leave.approval_status}
                        </div>
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
